<div class="opportunity pt-0">
  <div class="d-flex justify-content-between align-items-center">
    <h3 class="heading mb-0 mt-2">Inspection</h3>
    <div *ngIf="preview" class="d-flex align-items-center">
      <!-- <button *ngIf="!review" class="btn base-btn estimate-btn"
        [disabled]="!((estimates || optionalEstimates) &&( estimates.length || optionalEstimates.length))"
        (click)="reviewEstimate()">Review Inspection</button> -->
    </div>
  </div>
  <div class="opportunity-list">
    <div *ngIf="(estimates || optionalEstimates) &&( estimates.length || optionalEstimates.length); else noDataFound"
      class="table-responsive scroll-hide">
      <table class="table ">
        <thead class="p-2">
          <tr>
            <th scope="col" style="width: 48px;">Item</th>
            <!-- <th scope="col" style="width: 44px;">SKU</th> -->
            <th scope="col" style="width: 58px;">Image</th>
            <th scope="col">Item Name</th>
            <th scope="col">Description</th>
            <th scope="col">Video</th>
            <th scope="col" *ngIf="false">Charge Type</th>
            <th scope="col" *ngIf="false">Price</th>
            <th scope="col" *ngIf="false">Tax</th>
            <th scope="col" *ngIf="false">Qty</th>
            <th scope="col" *ngIf="false">Total</th>
            <th scope="col">Script</th>
            <th scope="col">Inspection</th>
            <th scope="col" *ngIf="false">Include</th>
            <th scope="col">Date</th>
            <th scope="col" *ngIf="false">Status</th>
            <th scope="col">Action</th>
          </tr>
        </thead>
        <tbody class="">

          <!-- NEW: Inspection Section grouping -->
          <ng-container *ngIf="estimates?.length; else legacyEstimates">
            <ng-container *ngFor="let section of estimates; let si = index">
              <!-- Section header row -->
              <tr class="inspection-header-row handIcon" (click)="toggleSection(section._id)">
                <td class="media-column">
                  <span class="chevron-icon" [class.rotated]="isSectionExpanded(section._id)">
                    <svg width="14" height="14" viewBox="0 0 24 24" fill="none">
                      <path d="M9 6l6 6-6 6" stroke="currentColor" stroke-width="2.5" stroke-linecap="round"
                        stroke-linejoin="round" />
                    </svg>
                  </span>
                </td>
                <!-- <td class="index-column">{{'---'}}</td> -->
                <td>{{'---'}}</td>
                <td>
                  <div class="d-flex align-items-center gap-2">
                    <span class="inspection-label">
                      {{ section.title?.length > 25 ? section.title.slice(0,25) + '...' : section.title }}
                    </span>
                    <span class="bundle-count-badge">{{section.items?.length || 0}}</span>
                  </div>
                </td>
                <td class="description">---</td>
                <td>---</td>
                <td *ngIf="false">---</td>
                <td *ngIf="false && hidePrice && !lumpSum">---</td>
                <td *ngIf="false && hidePrice && !lumpSum">---</td>
                <td *ngIf="false && hidePrice && !lumpSum">---</td>
                <td *ngIf="false && hidePrice && !lumpSum">---</td>
                <td [ngClass]="{'description': !work_order, 'workDesc': work_order}">---</td>
                <td><span class="btn">{{'---'}}</span></td>
                <td *ngIf="hidePrice">---</td>
                <td>---</td>
                <td *ngIf="false">---</td>
                <td>
                  <span class="pe-3 handIcon">
                    <img src="assets/images/visibility.svg" class="handIcon" (click)="reviewEstimate(section)" />
                  </span>
                </td>
              </tr>

              <!-- Section items (expanded) -->
              <ng-container *ngIf="isSectionExpanded(section._id)">
                <ng-container *ngFor="let estimate of section.items; let i = index">
                  <ng-container *ngIf="estimate" [ngTemplateOutlet]="itemRow"
                    [ngTemplateOutletContext]="{ estimate: estimate, i: i }">
                  </ng-container>
                </ng-container>
              </ng-container>

            </ng-container>
          </ng-container>

          <!-- Existing behaviour preserved exactly when there are no inspectionSections -->
          <ng-template #legacyEstimates>
            <ng-container *ngFor="let estimate of estimates; let i = index">
              <ng-container *ngIf="estimate" [ngTemplateOutlet]="itemRow"
                [ngTemplateOutletContext]="{ estimate: estimate, i: i }">
              </ng-container>
            </ng-container>
          </ng-template>

        </tbody>

        <!-- Reusable row template: your ORIGINAL per-item markup, unchanged,
             just parameterized via let-estimate / let-i instead of the *ngFor variables -->
        <ng-template #itemRow let-estimate="estimate" let-i="i">
          <ng-container *ngIf="estimate?.isBundle else regularIns">
            <!-- Bundle header row -->
            <tr class="bundle-header-row inspection-child-row handIcon"
              (click)="toggleBundle(estimate.bundleInstanceId)" (click)="review && viewEstimate(estimate)">
              <!-- Item index -->
              <td class="index-column">{{i + 1}}</td>
              <!-- SKU — bundles have no SKU -->
              <!-- <td>{{'---'}}</td> -->
              <td (click)="showImages(estimate.itemImage)">
                <div *ngIf="estimate.images.length >1 ; else showSingleImage" class="more-images ">
                  <span class="rounded-circle">{{'+'+ (estimate.images.length-1)}}</span>
                  <div class="image">
                    <img [src]="estimate.images[0].link" width="28px" height="28px" class="rounded-circle">
                  </div>
                </div>
                <ng-template #showSingleImage>
                  <img *ngIf="estimate.images.length else noMedia" [src]="estimate.images[0].link" width="28px"
                    height="28px" class="rounded-circle">
                  <ng-template #noMedia>
                    <div>---</div>
                  </ng-template>
                </ng-template>
              </td>
              <td [ngClass]="{'greyed-out-text': estimate?.quantity === 0}"><span [matTooltip]="estimate['itemName']">
                  {{ estimate['itemName'].length >
                  25 ? estimate['itemName'].slice(0, 25) + '...' :
                  estimate['itemName'] }}
                </span></td>
              <td class="description">
                <div>{{estimate['description']||'---'}}</div>
              </td>
              <td (click)="showImages(estimate.itemImage)">
                <div *ngIf="estimate.videos.length >1 ; else showSingleVideo" class="more-images ">
                  <span class="rounded-circle">{{'+'+ (estimate.videos.length-1)}}</span>
                  <div class="image">
                    <video [src]="estimate.videos[0].link" width="28px" height="28px" class="rounded-circle"></video>
                  </div>
                </div>
                <ng-template #showSingleVideo>
                  <video *ngIf="estimate.videos.length else noMedia" [src]="estimate.videos[0].link" width="28px"
                    height="28px" class="rounded-circle"></video>
                  <ng-template #noMedia>
                    <div>---</div>
                  </ng-template>
                </ng-template>
              </td>

              <td *ngIf="false">{{estimate['chargeType']}}</td>
              <td *ngIf="false && hidePrice && !lumpSum">{{'$' + estimate['price'] || '0.00'}}</td>
              <td *ngIf="false && hidePrice && !lumpSum">{{'$' + (estimate['tax'] || '0.00')}}</td>
              <td *ngIf="false && hidePrice && !lumpSum">{{estimate['quantity']}}</td>
              <td *ngIf="false && hidePrice && !lumpSum">{{'$'+estimate['total'] || '0.00'}}</td>
              <td
                [ngClass]="{'description': !work_order, 'workDesc': work_order, 'greyed-out-text': estimate?.quantity === 0}">
                <div>{{estimate['script']||'---'}}</div>
              </td>
              <td><span class="btn">{{'---'}}</span></td>
              <td *ngIf="hidePrice"><input class="form-check-input" type="checkbox"
                  [disabled]="estimate?.isEssential==true" (change)="selectEstimate($event,estimate._id,estimate)"
                  [checked]="estimate?.isInclude==true" /></td>
              <td>
                {{
                (true
                ? estimate['inspectionDate']
                : estimate['createdAt']
                )
                ? ((true ? estimate['inspectionDate'] : estimate['createdAt']).replace(' ', 'T') |
                date: dateFormat)
                : '---'
                }}
              </td>
              <td *ngIf="false">
                <span class="btn w-100"
                  [ngClass]="estimate['status'] == 0 ? 'orange-btn': estimate['status'] ==1 ? 'blue-btn' : estimate['status'] == 2 ? 'red-btn' : '---'">
                  {{estimate['status'] == 0 ? 'Pending Approval': estimate['status'] ==1 ? 'Approved' :
                  estimate['status'] == 2 ? 'Unapproved' : '---'}}</span>
              </td>
            </tr>

            <!-- Bundle child item rows (accordion) -->
            <ng-container *ngIf="isBundleExpanded(estimate.bundleInstanceId)">
              <tr *ngFor="let childItem of estimate.childItems; let ci = index"
                (click)="review && viewEstimate(childItem)"
                class="bundle-child-row inspection-child-row handIcon example-box">
                <!-- Item index (indented sub-index) -->
                <td [ngClass]="{'greyed-out-text': childItem?.quantity === 0}" class="index-column">
                </td>
                <!-- <td>{{childItem.sku}}</td> -->
                <td (click)="showImages(childItem.itemImage)">
                  <div *ngIf="childItem.images.length >1 ; else showSingleImage" class="more-images ">
                    <span class="rounded-circle">{{'+'+ (childItem.images.length-1)}}</span>
                    <div class="image">
                      <img [src]="childItem.images[0].link" width="28px" height="28px" class="rounded-circle">
                    </div>
                  </div>
                  <ng-template #showSingleImage>
                    <img *ngIf="childItem.images.length else noMedia" [src]="childItem.images[0].link" width="28px"
                      height="28px" class="rounded-circle">
                    <ng-template #noMedia>
                      <div>---</div>
                    </ng-template>
                  </ng-template>
                </td>
                <td [ngClass]="{'greyed-out-text': childItem?.quantity === 0}"><span
                    [matTooltip]="childItem['itemName']">
                    {{ childItem['itemName'].length >
                    25 ? childItem['itemName'].slice(0, 25) + '...' :
                    childItem['itemName'] }}
                  </span></td>
                <td class="description">
                  <div>{{childItem['description']||'---'}}</div>
                </td>
                <td (click)="showImages(childItem.itemImage)">
                  <div *ngIf="childItem.videos.length >1 ; else showSingleVideo" class="more-images ">
                    <span class="rounded-circle">{{'+'+ (childItem.videos.length-1)}}</span>
                    <div class="image">
                      <video [src]="childItem.videos[0].link" width="28px" height="28px" class="rounded-circle"></video>
                    </div>
                  </div>
                  <ng-template #showSingleVideo>
                    <video *ngIf="childItem.videos.length else noMedia" [src]="childItem.videos[0].link" width="28px"
                      height="28px" class="rounded-circle"></video>
                    <ng-template #noMedia>
                      <div>---</div>
                    </ng-template>
                  </ng-template>
                </td>

                <td *ngIf="false">{{childItem['chargeType']}}</td>
                <td *ngIf="false && hidePrice && !lumpSum">{{'$' + childItem['price'] || '0.00'}}</td>
                <td *ngIf="false && hidePrice && !lumpSum">{{'$' + (childItem['tax'] || '0.00')}}</td>
                <td *ngIf="false && hidePrice && !lumpSum">{{childItem['quantity']}}</td>
                <td *ngIf="false && hidePrice && !lumpSum">{{'$'+childItem['total'] || '0.00'}}</td>
                <td
                  [ngClass]="{'description': !work_order, 'workDesc': work_order, 'greyed-out-text': childItem?.quantity === 0}">
                  <div>{{childItem['script']||'---'}}</div>
                </td>
                <td><span class="btn"
                    [ngClass]="setInspectionStatus(childItem.inspectionId)">{{childItem?.inspection_data?.length
                    ? childItem?.inspection_data[0]?.fieldName : '---'}}</span></td>
                <td *ngIf="hidePrice"><input class="form-check-input" type="checkbox"
                    [disabled]="childItem?.isEssential==true" (change)="selectEstimate($event,childItem._id,childItem)"
                    [checked]="childItem?.isInclude==true" /></td>
                <td>
                  {{
                  (true
                  ? childItem['inspectionDate']
                  : childItem['createdAt']
                  )
                  ? ((true ? childItem['inspectionDate'] : childItem['createdAt']).replace(' ', 'T') |
                  date: dateFormat)
                  : '---'
                  }}
                </td>
                <td *ngIf="false">
                  <span class="btn w-100"
                    [ngClass]="childItem['status'] == 0 ? 'orange-btn': childItem['status'] ==1 ? 'blue-btn' : childItem['status'] == 2 ? 'red-btn' : '---'">
                    {{childItem['status'] == 0 ? 'Pending Approval': childItem['status'] ==1 ? 'Approved' :
                    childItem['status'] == 2 ? 'Unapproved' : '---'}}</span>
                </td>
              </tr>
            </ng-container>
          </ng-container>
          <ng-template #regularIns>
            <tr class="inspection-child-row" (click)="review && viewEstimate(estimate)">
              <td>{{i+1}}</td>
              <!-- <td>{{estimate.sku}}</td> -->
              <td (click)="showImages(estimate.itemImage)">
                <div *ngIf="estimate?.images?.length >1 ; else showSingleImage" class="more-images ">
                  <span class="rounded-circle">{{'+'+ (estimate?.images.length-1)}}</span>
                  <div class="image">
                    <img [src]="estimate?.images[0].link" width="28px" height="28px" class="rounded-circle">
                  </div>
                </div>
                <ng-template #showSingleImage>
                  <img *ngIf="estimate?.images?.length else noMedia" [src]="estimate.images[0].link" width="28px"
                    height="28px" class="rounded-circle">
                  <ng-template #noMedia>
                    <div>---</div>
                  </ng-template>
                </ng-template>
              </td>
              <td [ngClass]="{'greyed-out-text': estimate?.quantity === 0}"><span [matTooltip]="estimate['itemName']">
                  {{ estimate['itemName']?.length >
                  25 ? estimate['itemName'].slice(0, 25) + '...' :
                  estimate['itemName'] }}
                </span></td>
              <td class="description">
                <div>{{estimate['description']||'---'}}</div>
              </td>
              <td (click)="showImages(estimate.itemImage)">
                <div *ngIf="estimate?.videos?.length >1 ; else showSingleVideo" class="more-images ">
                  <span class="rounded-circle">{{'+'+ (estimate.videos.length-1)}}</span>
                  <div class="image">
                    <video [src]="estimate.videos[0].link" width="28px" height="28px" class="rounded-circle"></video>
                  </div>
                </div>
                <ng-template #showSingleVideo>
                  <video *ngIf="estimate?.videos?.length else noMedia" [src]="estimate.videos[0].link" width="28px"
                    height="28px" class="rounded-circle"></video>
                  <ng-template #noMedia>
                    <div>---</div>
                  </ng-template>
                </ng-template>
              </td>

              <td *ngIf="false">{{estimate['chargeType']}}</td>
              <td *ngIf="false && hidePrice && !lumpSum">{{'$' + estimate['price'] || '0.00'}}</td>
              <td *ngIf="false && hidePrice && !lumpSum">{{'$' + (estimate['tax'] || '0.00')}}</td>
              <td *ngIf="false && hidePrice && !lumpSum">{{estimate['quantity']}}</td>
              <td *ngIf="false && hidePrice && !lumpSum">{{'$'+estimate['total'] || '0.00'}}</td>
              <td
                [ngClass]="{'description': !work_order, 'workDesc': work_order, 'greyed-out-text': estimate?.quantity === 0}">
                <div>{{estimate['script']||'---'}}</div>
              </td>
              <td><span class="btn"
                  [ngClass]="setInspectionStatus(estimate.inspectionId)">{{estimate?.inspection_data?.length
                  ? estimate?.inspection_data[0]?.fieldName : '---'}}</span></td>
              <td *ngIf="hidePrice"><input class="form-check-input" type="checkbox"
                  [disabled]="estimate?.isEssential==true" (change)="selectEstimate($event,estimate._id,estimate)"
                  [checked]="estimate?.isInclude==true" /></td>
              <td>
                {{
                (true
                ? estimate['inspectionDate']
                : estimate['createdAt']
                )
                ? ((true ? estimate['inspectionDate'] : estimate['createdAt']).replace(' ', 'T') |
                date: dateFormat)
                : '---'
                }}
              </td>
              <td *ngIf="false">
                <span class="btn w-100"
                  [ngClass]="estimate['status'] == 0 ? 'orange-btn': estimate['status'] ==1 ? 'blue-btn' : estimate['status'] == 2 ? 'red-btn' : '---'">
                  {{estimate['status'] == 0 ? 'Pending Approval': estimate['status'] ==1 ? 'Approved' :
                  estimate['status'] == 2 ? 'Unapproved' : '---'}}</span>
              </td>
            </tr>
          </ng-template>
        </ng-template>

        <thead *ngIf="optionalEstimates && optionalEstimates.length" class="optional">
          <tr class="">
            <th colspan="15" class="">Optional Items</th>
          </tr>
        </thead>
        <tbody *ngIf="optionalEstimates && optionalEstimates.length">
          <tr *ngFor="let optionalEstimate of includedEstimates;let i=index"
            (click)="review && viewEstimate(optionalEstimate)">
            <td>{{i+(estimates.length+1)}}</td>
            <!-- <td>{{optionalEstimate.sku}}</td> -->
            <td (click)="showImages(optionalEstimate.itemImage)">
              <div *ngIf="optionalEstimate.images.length >1 ; else showSingleImage" class="more-images ">
                <span class="rounded-circle">{{'+'+ (optionalEstimate.images.length-1)}}</span>
                <div class="image">
                  {{optionalEstimate.itemImage[0].link}}
                  <img [src]="optionalEstimate.itemImage[0].link" width="28px" height="28px" class="rounded-circle">
                </div>
              </div>
              <ng-template #showSingleImage>
                <img *ngIf="optionalEstimate.itemImage.length else noMedia" [src]="optionalEstimate.itemImage[0].link"
                  width="28px" height="28px" class="rounded-circle">
                <ng-template #noMedia>
                  <div>---</div>
                </ng-template>
              </ng-template>
            </td>
            <td>{{optionalEstimate['itemName']}}</td>
            <td class="description">
              <div>{{optionalEstimate['description']}}</div>
            </td>
            <td (click)="showImages(optionalEstimate.itemImage)">
              <div *ngIf="optionalEstimate.videos.length >1 ; else showSingleVideo" class="more-images ">
                <span class="rounded-circle">{{'+'+ (optionalEstimate.videos.length-1)}}</span>
                <div class="image">
                  <video [src]="optionalEstimate.videos[0]" width="28px" height="28px" class="rounded-circle"></video>
                </div>
              </div>
              <ng-template #showSingleVideo>
                <video *ngIf="optionalEstimate.videos.length else noMedia" [src]="optionalEstimate.videos[0]"
                  width="28px" height="28px" class="rounded-circle"></video>
                <ng-template #noMedia>
                  <div>---</div>
                </ng-template>
              </ng-template>
            </td>
            <td>{{optionalEstimate['chargeType']}}</td>
            <td *ngIf="hidePrice && !lumpSum">{{'$'+ optionalEstimate['price']||'0.00'}}</td>
            <td *ngIf="hidePrice && !lumpSum">{{'$' +(optionalEstimate['tax'] || '0.00')}}</td>
            <td *ngIf="hidePrice && !lumpSum">{{optionalEstimate['quantity']}}</td>
            <td *ngIf="hidePrice && !lumpSum">{{'$ '+optionalEstimate['total'] || '0.00'}}</td>
            <td><span class="btn"
                [ngClass]="setInspectionStatus(optionalEstimate.inspectionId)">{{optionalEstimate.inspectionStatus
                || '---'}}</span></td>
            <td *ngIf="hidePrice"><input class="form-check-input" type="checkbox" [checked]='optionalEstimate.isInclude'
                [disabled]="!review" (change)="selectEstimate($event,optionalEstimate._id,optionalEstimate)" /></td>
            <td>{{optionalEstimate['createdAt'].replace(' ','T')| date: dateFormat}}</td>
            <td>
              <span class="btn w-100"
                [ngClass]="optionalEstimate['status'] == 0 ? 'orange-btn': optionalEstimate['status'] == 1 ? 'blue-btn' : optionalEstimate['status'] == 2 ? 'red-btn' : '---'">{{optionalEstimate['status']
                == 0 ? 'Pending Approval': optionalEstimate['status'] == 1 ? 'Approved' :
                optionalEstimate['status'] == 2 ? 'Unapproved' : '---'}}</span>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
    <div
      *ngIf="(hidePrice || lumpSum) && (review && (estimates || optionalEstimates) &&( estimates.length || optionalEstimates.length))"
      class="w-100">
      <hr class="dashed-line" />
      <div class="py-3 d-flex flex-column align-items-end">
        <div class="d-flex justify-content-between align-items-center amount">
          <h3 class="amount-heading pb-0 mb-0 mx-1">SubTotal:</h3>
          <span class="amount-heading" *ngIf="!review">{{'$'+ calculateAmount('total')}}</span>
          <span class="amount-heading" *ngIf="review">{{'$'+ (totalAmount - taxAmount).toFixed(2)}}</span>
        </div>
        <div class="d-flex justify-content-between align-items-center amount">
          <h3 class="amount-breakup pb-0 mb-0 mx-1">Tax:</h3>
          <span class="amount-breakup" *ngIf="review">{{'$'+ taxAmount}}</span>
        </div>
        <div class="d-flex justify-content-between align-items-center amount">
          <h3 class="amount-breakup pb-0 mb-0 mx-1">Total:</h3>
          <span class="amount-breakup" *ngIf="review">{{'$'+ totalAmount}}</span>
        </div>
      </div>
    </div>
    <ng-template #noDataFound>
      <div class="no-data">No Inspection Found.</div>
    </ng-template>
  </div>
  <ng-container *ngIf="isPreferredUser">
    <div class="d-flex align-items-center justify-content-center mt-2" *ngIf="location">
      <button [disabled]="!approveEstimateIds.length || (!hidePrice && !lumpSum)"
        class="btn d-flex base-btn estimate-btn approve-btn" (click)="approveEstimate()">Approve All Selected
        Items</button>
    </div>
  </ng-container>

</div>
